import { isEuEeaCountry } from '../ports/catalog.js';
import type { EuRoute, MrvReviewStatus } from './lists.js';

/**
 * AB rota taraması (ADR 0058 §2; tel kafes "EU route screening"): kalkış ve sonraki limanın ülkesi
 * AB/AEA'da mı. Ön taramadır, nihai MRV kapsam kararı değildir [(AB) 2015/757 md. 9–10]; kapsam
 * MRV modülünde (Faz 3). Saf işlevler.
 */

/** UN/LOCODE'un ülke öneki; WPI kodunda ve kodsuz limanda ülke koddan çıkmaz. */
export function portCountry(code: string | null | undefined): string | null {
  return code && /^[A-Z]{2}[A-Z0-9]{3}$/.test(code) ? code.slice(0, 2) : null;
}

export function deriveEuRoute(
  fromCode: string | null | undefined,
  toCode: string | null | undefined,
): EuRoute {
  const from = portCountry(fromCode);
  const to = portCountry(toCode);
  if (!from || !to) return 'unknown';
  const a = isEuEeaCountry(from) ? 'eu' : 'non_eu';
  const b = isEuEeaCountry(to) ? 'eu' : 'non_eu';
  return `${a}_${b}` as EuRoute;
}

/**
 * MRV inceleme durumu, saklanmaz: AB limanına dokunan ya da bilinmeyen rota "Review required",
 * AB dışı rota "Not assessed" (tel kafes karar matrisi: kapsam ayrıca değerlendirilir; muafiyet
 * varsayılmaz). "Assessed" MRV modülünün kararıdır.
 */
export function mrvReviewStatus(route: EuRoute | null | undefined): MrvReviewStatus {
  return route === 'non_eu_non_eu' ? 'not_assessed' : 'review_required';
}
